import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { PhrasingContent } from 'mdast';
import type { FromPMHandlers } from '../types';
import { convertInlineChildren } from '../utils';

export function tableCell(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: PhrasingContent[]; type: 'tableCell' } {
	const children: PhrasingContent[] = [];
	// Table cells contain paragraphs wrapping inline content; flatten them.
	// Use convertInlineChildren so non-text inline nodes (hard_break, image,
	// inlineCode, etc.) are handled via the handlers map rather than dropped.
	node.forEach((child) => {
		if (child.type.name === 'paragraph') {
			children.push(...convertInlineChildren(child, handlers));
		}
	});
	return { type: 'tableCell' as const, children };
}
